const fontWeight = {
  regular: 400,
  semiBold: 600,
};

export type SystemFontWeightMap = typeof fontWeight;
export type SystemFontWeight = keyof SystemFontWeightMap;
export default fontWeight;
